import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./family-and-friends.css";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import PaymentSuccess from "./components/PaymentSuccess";
import PaymentFailure from "./components/PaymentFailure";
import {createBrowserHistory} from 'history';
import {CookiesProvider} from "react-cookie";
import Converted from "./components/Converted";
import Expired from "./components/Expired";
import MultiStepFormAA from "./components/MultiStepFormAA";
import SessionExpired from "./components/SessionExpired";
import Register from "./components/Register";
import {detectSource} from "./utils/sourceDetection";

export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL
});

const DefaultTheme = React.lazy(() => import('./components/DefaultTheme'));
const GaspyTheme = React.lazy(() => import('./components/GaspyTheme'));
const AATheme = React.lazy(() => import('./components/AATheme'));
const VtnzTheme = React.lazy(() => import('./components/VtnzTheme'));

const ThemeSelector = ({ children }) => {
  const source = detectSource();
    return (
        <>
            <React.Suspense fallback={<></>}>
                {source === 'AA' && <AATheme />}
                {source === 'GASPY' && <GaspyTheme/>}
                {source === 'VTNZ' && <VtnzTheme/>}
                {source !== 'AA' && source !== 'GASPY' && source !== 'VTNZ' && <DefaultTheme/>}
            </React.Suspense>
            {children}
        </>
    )
}

ReactDOM.render(
    <>
        <ThemeSelector>


    <CookiesProvider>
    <Router history={history}>
        <Routes>
          {/* New clean routes */}
          <Route path="/mbi" element={<MultiStepFormAA/>}/>
          <Route path="/mbi/cardpaymentsuccess" element={<PaymentSuccess/>}/>
          <Route path="/mbi/cardpaymentfailed" element={<PaymentFailure/>}/>
          <Route path="/paymentsuccess" element={<PaymentSuccess/>}/>
          <Route path="/paymentfailed" element={<PaymentFailure/>}/>
          <Route path="/mbi/session-expired" element={<SessionExpired/>}/>
          <Route path="/mbi/expired" element={<Expired/>}/>
          <Route path="/mbi/converted" element={<Converted/>}/>
          <Route path="/turners/*" element={<Register/>}/>

          <Route path="/mbi/paymentsuccess" element={<PaymentSuccess/>}/>
          <Route path="mbi/paymentfailed" element={<PaymentFailure/>}/>

        </Routes>
        {/*  <div>
            <Container>
                <Footer/>
            </Container>
        </div>*/}
    </Router>
    </CookiesProvider></ThemeSelector>
    </>, document.getElementById("root"));

